import React from 'react';
import { BoxIcon, XIcon } from 'lucide-react';
import type { PM } from './useProductManager';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
interface BookBoxDetailsSectionProps {
  pm: PM;
}
export const BookBoxDetailsSection: React.FC<BookBoxDetailsSectionProps> = ({
  pm
}) => {
  const dk = useDarkClasses();
  const {
    darkMode,
    bookBoxForm,
    includedItemInput,
    setIncludedItemInput,
    customizationInput,
    setCustomizationInput,
    handleAddIncludedItem,
    handleRemoveIncludedItem,
    handleAddCustomization,
    handleRemoveCustomization
  } = pm;
  return <div className={`p-6 rounded-xl shadow-sm ${dk.card}`} data-id="element-20098" data-mp="sk859th00jt7">
      <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textHeading}`} data-id="element-20099" data-mp="shlxptu3y4az">
        <BoxIcon className="w-5 h-5 mr-2 text-pink-500" data-id="element-20100" data-mp="xg6q5734bjov" />
        Box Details
      </h2>
      <div className="space-y-6" data-id="element-20101" data-mp="1l611fk7sh070">
        <div data-id="element-20102" data-mp="1pzdp9s4n92yp">
          <label className={`block text-sm font-medium mb-2 ${dk.textSecondary}`} data-id="element-20103" data-mp="1pz4026rfazu2">
            Included Items
          </label>
          <div className="flex gap-2 mb-2" data-id="element-20104" data-mp="24u6fut0paghu">
            <input type="text" value={includedItemInput} onChange={e => setIncludedItemInput(e.target.value)} className={`flex-1 p-2 rounded-md border ${dk.inputOnCard}`} placeholder="Add item..." data-id="element-20105" data-mp="1zy7nkuc94ec5" />
            <button onClick={handleAddIncludedItem} className="px-4 py-2 bg-pink-500 text-white rounded-md hover:bg-pink-600" data-id="element-20106" data-mp="2nmhegaobnsa5">
              Add
            </button>
          </div>
          <ul className="space-y-2" data-id="element-20107" data-mp="2xk58szi0mxrs">
            {bookBoxForm.includedItems?.map((item, idx) => <li key={idx} className={`flex justify-between items-center p-2 rounded ${dk.surfaceMuted}`} data-id="element-20108" data-mp="2sn55gwcjw94d">
                <span className={`text-sm ${dk.textPrimary}`} data-id="element-20109" data-mp="y82ib5az534m">{item}</span>
                <button onClick={() => handleRemoveIncludedItem(idx)} className="text-red-500" data-id="element-20110" data-mp="y9x74upd9fdz">
                  <XIcon className="w-4 h-4" data-id="element-20111" data-mp="1rxa1cvu2bhq6" />
                </button>
              </li>)}
          </ul>
        </div>
        <div data-id="element-20112" data-mp="1wvbgx6sa4yww">
          <label className={`block text-sm font-medium mb-2 ${dk.textSecondary}`} data-id="element-20113" data-mp="1wvl9910sri5r">
            Customization Options
          </label>
          <div className="flex gap-2 mb-2" data-id="element-20114" data-mp="26vvlaib3ijjc">
            <input type="text" value={customizationInput} onChange={e => setCustomizationInput(e.target.value)} className={`flex-1 p-2 rounded-md border ${dk.inputOnCard}`} placeholder="Add option..." data-id="element-20115" data-mp="26szpazit64xj" />
            <button onClick={handleAddCustomization} className="px-4 py-2 bg-pink-500 text-white rounded-md hover:bg-pink-600" data-id="element-20116" data-mp="2klyzqn3qh8y8">
              Add
            </button>
          </div>
          <ul className="space-y-2" data-id="element-20117" data-mp="2uiah3ri6kozj">
            {bookBoxForm.customizationOptions?.map((opt, idx) => <li key={idx} className={`flex justify-between items-center p-2 rounded ${dk.surfaceMuted}`} data-id="element-20118" data-mp="dy86o3tj1zcp">
                <span className={`text-sm ${dk.textPrimary}`} data-id="element-20119" data-mp="8zwzk0uma2y6">{opt}</span>
                <button onClick={() => handleRemoveCustomization(idx)} className="text-red-500" data-id="element-20120" data-mp="40u2p3osj31a">
                  <XIcon className="w-4 h-4" data-id="element-20121" data-mp="11pvolw8ta02u" />
                </button>
              </li>)}
          </ul>
        </div>
      </div>
    </div>;
};